import React, { ReactNode } from 'react'
import styles from './StripBox.module.scss'
import { Image } from 'react-bootstrap'

import classNames from 'classnames'

export type DataType = {
  image: string | ReactNode
  value: string
}

export interface IStripCardProps {
  label: string
  datas?: DataType[]
  image?: string | ReactNode
  text?: string
  value?: string
  rotating?: boolean
}

export const StripCard: React.FC<
  IStripCardProps & React.HTMLProps<HTMLDivElement>
> = ({ ...props }) => {
  let manyClass = classNames([
    styles.stripCard,
    props.className
      ? props.className === 'blue'
        ? styles.blue
        : props.className === 'cyan'
        ? styles.cyan
        : props.className === 'green'
        ? styles.green
        : props.className === 'reddish_pink'
        ? styles.reddishPink
        : props.className === 'orange'
        ? styles.orange
        : props.className
      : null
  ])

  return (
    <div className={manyClass}>
      <label className={styles.stripLabel}>{props.label}</label>
      <div className={styles.stripContent}>
        {props.datas ? (
          props.datas.map((dataType: DataType, index: number) => (
            <div key={`strip-group-${index}`} className={styles.stripGroup}>
              {typeof dataType.image === 'string' ? (
                <Image src={dataType.image} className={styles.stripImage} />
              ) : (
                dataType.image
              )}
              <div className={styles.stripValue}>{dataType.value}</div>
            </div>
          ))
        ) : (
          <>
            {props.image && (
              <div className={`${props.rotating ? 'rotating' : ''}`}>
                {typeof props.image === 'string' ? (
                  <Image src={props.image} className={styles.stripImage} />
                ) : (
                  props.image
                )}
              </div>
            )}
            {props.text !== undefined && props.value !== undefined ? (
              <div className={styles.stripTextValue}>
                <div className={styles.stripText}>{props.text}</div>
                <div className={styles.stripValue}>{props.value}</div>
              </div>
            ) : props.text !== undefined && props.value === undefined ? (
              <div className={styles.stripValue}>{props.text}</div>
            ) : (
              <div className={styles.stripValue}>{props.value}</div>
            )}
          </>
        )}
      </div>
    </div>
  )
}

export interface IStripBoxProps {}
export const StripBox: React.FC<
  IStripBoxProps & React.HTMLProps<HTMLDivElement>
> = ({ children, ...props }) => {
  return (
    <div className={styles.stripBox} {...props}>
      {children}
    </div>
  )
}
